@if (view && view.viewType === ViewType.Workflow) {
    <app-workflow-datas-list [configuration]="configuration" (folderDisplayed)="onFolderDisplayed($event, view)"></app-workflow-datas-list>
} @else if (view && view.viewType === ViewType.Box) {
    <app-boxes-data [configuration]="configuration" (folderDisplayed)="onFolderDisplayed($event, view)"></app-boxes-data>
} @else if (view && view.viewType === ViewType.ArchivingWorkflow) {
    <app-archiving-workflow-datas-list [configuration]="configuration" (folderDisplayed)="onFolderDisplayed($event, view)"></app-archiving-workflow-datas-list>
} @else {
    <!-- TODO Archivage -->
}
